<div class="container-fluid main-layout-container">
  <div class="row mx-0 main-row">
    <div class="col menubar mx-0 newmenu" *ngIf="!publicReviewLink && !isReportingView && !publicShareLink">
      <mtm-left-sidebar-floating
        [campaignName]="campaignName"
        [isAgencyUser]="isAgencyUser"
        [hasReportMenus]="hasReportMenus"
        [hasSelfTrainerMenus]="hasSelfTrainerMenus" />
    </div>

    <div class="col mainarea pb-0 mx-0 flex-grow-1 px-0" [class.p-2]="publicReviewLink">
      <div class="d-flex h-100">
        <div
          class="main-container flex-grow-1"
          [class.has-right-pane]="themeOptions.rightPane"
          [class.d-flex]="isComparePage"
          [class.flex-column]="isComparePage"
          [ngClass]="themeOptions.mainContainerClasses">
          <header
            class="app-header p-1"
            [class.compare-page]="isComparePage"
            *ngIf="!themeOptions.isPublicPage && !isReportingView && !isComparePage">
            <div
              class="header-container"
              [class.hidden-mobile]="!isCampaignDrivePath"
              [class.hidden-mobile-res]="isCampaignDrivePath"
              style="display: flex; flex-wrap: wrap">
              <div class="header-left">
                <button class="sidebar-toggle" (click)="toggleSidebar()" aria-label="Toggle menu">
                  <span class="toggle-line"></span>
                  <span class="toggle-line"></span>
                  <span class="toggle-line"></span>
                </button>
                <div class="header-logo" (click)="goToInitialPage()" style="cursor: pointer">
                  <img
                    [src]="brandLogo"
                    onerror="this.src = '/assets/svg/sidebar/logo.svg'"
                    [alt]="brandName || 'MTM'" />
                </div>
                <div
                  class="header-nav-buttons d-flex align-items-center"
                  *ngIf="isOnProjectSubsection || isKpfWidgetExpanded">
                  <button
                    class="btn navigation-button back-button pointer d-flex align-items-center justify-content-center"
                    [disabled]="!canNavigateAssets"
                    (click)="$event.stopPropagation(); navigateToPrevious()"
                    aria-label="Previous asset">
                    <i class="fa fa-chevron-left" aria-hidden="true"></i>
                  </button>
                  <button
                    class="btn navigation-button next-button pointer d-flex align-items-center justify-content-center"
                    [disabled]="!canNavigateAssets"
                    (click)="$event.stopPropagation(); navigateToNext()"
                    aria-label="Next asset">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </button>
                </div>
                <!-- <div
                  class="image-container-newmenu"
                  *ngIf="themeOptions.hasHeaderInfo && (headerInfo.avatarImage || headerInfo.avatarName)">
                  <mtm-image
                    [name]="headerInfo.avatarName"
                    [isSquare]="true"
                    [imageUrl]="headerInfo.avatarImage"
                    [cacheBuster]="cacheBuster"
                    [borderRadius]="'50%'" />
                </div> -->
                <div class="breadcrumb-wrapper d-flex align-items-center">
                  <mtm-breadcrumb-component></mtm-breadcrumb-component>
                  <div
                    *ngIf="showProjectBreadcrumb"
                    class="mtm-breadcrumb-project-container d-flex align-items-center ms-2">
                    <!-- <mtm-item-icon
                      *ngIf="!!projectService?.project?.id"
                      class="me-1"
                      [containerWidth]="'24px'"
                      [generatedTextColor]="true"
                      [height]="'24px'"
                      [imageUrl]="projectAvatarUrl"
                      [name]="projectName"
                      [width]="'24px'"
                      [cacheBuster]="cacheBuster">
                    </mtm-item-icon> -->

                    <mtm-breadcrumb-project (selectNode)="navigateToNode($event)" [isDashboard]="isDashboard">
                    </mtm-breadcrumb-project>
                  </div>
                </div>
                <mtm-version-dropdown></mtm-version-dropdown>
                <!-- <mtm-asset-info-toggle></mtm-asset-info-toggle>
                <mtm-download-asset-button></mtm-download-asset-button> -->
              </div>
              <div class="header-right">
                <div class="d-flex w-100" *ngIf="themeOptions?.searchPanel">
                  <ng-container [ngTemplateOutlet]="themeOptions.searchPanel"></ng-container>
                </div>
                <div *ngIf="themeOptions?.header">
                  <ng-container [ngTemplateOutlet]="themeOptions.header"></ng-container>
                </div>
                <top-nav></top-nav>
              </div>
            </div>

            <div [class.visible-mobile]="!isCampaignDrivePath" [class.visible-mobile-res]="isCampaignDrivePath">
              <div class="header-container">
                <div class="header-left">
                  <button class="sidebar-toggle" (click)="toggleSidebar()" aria-label="Toggle menu">
                    <span class="toggle-line"></span>
                    <span class="toggle-line"></span>
                    <span class="toggle-line"></span>
                  </button>
                  <div class="header-logo" (click)="goToInitialPage()" style="cursor: pointer">
                    <img src="/assets/svg/sidebar/logo.svg" alt="MTM" />
                  </div>
                  <div
                    class="header-nav-buttons d-flex align-items-center"
                    *ngIf="isOnProjectSubsection || isKpfWidgetExpanded">
                    <button
                      class="btn navigation-button back-button pointer d-flex align-items-center justify-content-center"
                      [disabled]="!canNavigateAssets"
                      (click)="$event.stopPropagation(); navigateToPrevious()"
                      aria-label="Previous asset">
                      <i class="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                    <button
                      class="btn navigation-button next-button pointer d-flex align-items-center justify-content-center"
                      [disabled]="!canNavigateAssets"
                      (click)="$event.stopPropagation(); navigateToNext()"
                      aria-label="Next asset">
                      <i class="fa fa-chevron-right" aria-hidden="true"></i>
                    </button>
                  </div>
                  <!-- <div
                    class="image-container-newmenu"
                    *ngIf="themeOptions.hasHeaderInfo && (headerInfo.avatarImage || headerInfo.avatarName)">
                    <mtm-image
                      [name]="headerInfo.avatarName"
                      [isSquare]="true"
                      [imageUrl]="headerInfo.avatarImage"
                      [cacheBuster]="cacheBuster"
                      [borderRadius]="'50%'" />
                  </div> -->
                  <div class="breadcrumb-wrapper d-flex align-items-center">
                    <mtm-breadcrumb-component></mtm-breadcrumb-component>
                    <div
                      *ngIf="showProjectBreadcrumb"
                      class="mtm-breadcrumb-project-container d-flex align-items-center ms-2">
                      <!-- <mtm-item-icon
                        *ngIf="!!projectService?.project?.id"
                        class="me-1"
                        [containerWidth]="'24px'"
                        [generatedTextColor]="true"
                        [height]="'24px'"
                        [imageUrl]="projectAvatarUrl"
                        [name]="projectName"
                        [width]="'24px'"
                        [cacheBuster]="cacheBuster">
                      </mtm-item-icon> -->

                      <mtm-breadcrumb-project (selectNode)="navigateToNode($event)" [isDashboard]="isDashboard">
                      </mtm-breadcrumb-project>
                    </div>
                  </div>
                </div>
                <div class="header-right">
                  <top-nav></top-nav>
                </div>
              </div>
              <div
                class="header-container"
                *ngIf="themeOptions.searchPanel || themeOptions?.header"
                style="border-top: 1px solid #d6ddea">
                <div class="w-100" *ngIf="themeOptions?.searchPanel">
                  <ng-container [ngTemplateOutlet]="themeOptions.searchPanel"></ng-container>
                </div>
                <div class="w-100" *ngIf="themeOptions?.header">
                  <ng-container [ngTemplateOutlet]="themeOptions.header"></ng-container>
                </div>
              </div>
            </div>
          </header>

          <section>
            <ng-container></ng-container>
          </section>

          <div
            #rootLayoutContainer
            class="root-layout"
            [style.--org-feed-w]="orgFeedWidth + 'px'"
            [class.flex-fill]="isComparePage"
            [class.compare-page]="isComparePage"
            [ngClass]="{
              'tasks-manager-page': isTasksPage,
              'top-shift': false,
              'page-with-media-preview-comments-chat': isMediaPreviewCommentsChatShowing,
              'media-preview-comments-chat-expanded': !commentsCollapsed,
              'page-with-platform-comments-chat': isPlatformCommentsChatShowing && !isMediaPreviewCommentsChatShowing,
              'comment-panel-fullsize': isCommentPanelFullSize,
              'campaign-drive-path': isCampaignDrivePath,
              'drive-mode': !!themeOptions?.driveMode,
              'task-panel-open': isTaskPanelOpen,
              'drive-org-fill': isOrgDrivePage && !!(platformChatState.context$ | async)?.driveAnchorUuid,
              'drive-org-comments':
                isOrgDrivePage && !!(platformChatState.context$ | async)?.driveAnchorUuid && !isTaskPanelOpen,
              'drive-org-comments-open':
                isOrgDrivePage &&
                !!(platformChatState.context$ | async)?.driveAnchorUuid &&
                !isTaskPanelOpen &&
                isOrgDriveCommentsOpen,
            }">
            <div
              class="w-100"
              [class.hidden]="isCommentPanelFullSize"
              [class.w-100--with-rail]="driveRightRail.visible()">
              <div
                class="left-content-wrapper"
                [class.left-content-wrapper-compare]="!isComparePage"
                [class.resizing-left-content]="shouldShowBlur"
                [class.h-100]="isComparePage">
                <router-outlet></router-outlet>
                @if (isReportingView) {
                  <mtm-zoom-in-out></mtm-zoom-in-out>
                }
              </div>
              @if (shouldShowBlur) {
                <div class="blur-overlay"></div>
                <div class="resize-indicator">
                  <mtm-resize-indicator-icon></mtm-resize-indicator-icon>
                </div>
              }
              <!-- The drive surfaces' right rail (feed, tasks, notifications, recent activity):
                   inside the content column, pinned at its top right, so where this column
                   scrolls (workspace / campaign) the scrollbar runs at the window edge, past
                   the rail. It only shows while no feed or task panel is open, so it is always
                   the rightmost thing on the row. -->
              @if (driveRightRail.visible()) {
                <mtm-drive-right-rail class="drive-right-rail">
                  <selector-notification-dropdown [railMode]="true" />
                </mtm-drive-right-rail>
              }
            </div>
            <mtm-sash-vertical
              [enabled]="isSashEnabled"
              [widthPx]="sashWidthPx"
              [minPx]="commentPanelWidthService.minWidth"
              [maxViewportPercent]="sashMaxViewportPercent"
              [resetWidthPx]="toleranceWidth"
              [class.comment-loading]="isCommentLoading && !isOrgFeedResizable"
              [class.disabled]="!isSashEnabled"
              [ngClass]="{ 'comment-expanded': commentWrapperWidth || isOrgFeedResizable }"
              (widthPxChange)="onCommentPanelWidthChange($event)"
              (isFullModeChange)="sashIsFullMode = $event"
              (resetClicked)="onResetClicked()">
            </mtm-sash-vertical>
            @if (enableTaskFeature && !isComparePage) {
              <div
                class="comment-wrapper"
                [class.shared-link-page]="publicReviewLink || publicShareLink"
                [class.fullscreen]="isFullscreen"
                [class.comment-wrapper-hidden]="shouldHideCommentWrapper"
                [class.panel-swap]="driveRightRail.swapping()"
                (transitionend)="onCommentWrapperTransitionEnd($event)"
                (transitioncancel)="onCommentWrapperTransitionEnd($event)"
                [ngStyle]="commentWrapperStyle"
                [ngClass]="commentWrapperClassMap"
                [style.width.px]="commentWrapperWidth"
                [style.display]="rightViewMode === 'task' ? 'block' : 'none'">
                <mtm-platform-task-interface
                  [entityType]="(platformTaskState.context$ | async)?.entityType"
                  [pageId]="(platformTaskState.context$ | async)?.pageId"
                  [entityName]="(platformTaskState.context$ | async)?.entityName"
                  [projectId]="(platformTaskState.context$ | async)?.projectId"
                  (isLoadingChange)="onCommentLoadingChange($event)">
                </mtm-platform-task-interface
              ></div>
            }
            @if (!isComparePage && !showDriveSurface && !(platformChatState.context$ | async)?.driveAnchorUuid) {
              <div
                class="comment-wrapper"
                [class.shared-link-page]="publicReviewLink || publicShareLink"
                [class.fullscreen]="isFullscreen"
                [class.comment-wrapper-hidden]="shouldHideCommentWrapper"
                (transitionend)="onCommentWrapperTransitionEnd($event)"
                (transitioncancel)="onCommentWrapperTransitionEnd($event)"
                [ngStyle]="commentWrapperStyle"
                [ngClass]="commentWrapperClassMap"
                [style.width.px]="commentWrapperWidth"
                [style.display]="rightViewMode === 'comment' ? 'flex' : 'none'">
                @if (!isMediaPreviewCommentsChatShowing && !isNavigatingToProjectDashboard) {
                  <div
                    class="comment-right-panel flex-column platform-comments-chat-container h-100 w-100"
                    [class.fullscreen]="isFullscreen"
                    [class.d-md-flex]="isPlatformCommentsChatShowing && !isMediaPreviewCommentsChatShowing"
                    [hidden]="!(isPlatformCommentsChatShowing && !isMediaPreviewCommentsChatShowing)">
                    <mtm-platform-comments-chat
                      [page]="(platformChatState.context$ | async)?.page"
                      [pageId]="(platformChatState.context$ | async)?.pageId"
                      [entityType]="(platformChatState.context$ | async)?.entityType"
                      [entityName]="(platformChatState.context$ | async)?.entityName"
                      [projectId]="(platformChatState.context$ | async)?.projectId"
                      [participants]="(platformChatState.context$ | async)?.participants"
                      [viewMode]="isCommentPanelFullSize ? 'split' : 'toggle'"
                      (isLoadingChange)="onCommentLoadingChange($event)">
                    </mtm-platform-comments-chat>
                  </div>
                }
                @if (isMediaPreviewCommentsChatShowing && hasMediaPreviewCommentsTemplate) {
                  <div
                    [hidden]="!isMediaPreviewCommentsChatShowing"
                    class="comment-right-panel flex-column media-preview-comments-chat-container h-100 w-100"
                    [class.d-md-flex]="isMediaPreviewCommentsChatShowing && !commentsCollapsed"
                    [class.fullscreen]="isFullscreen">
                    <ng-container [ngTemplateOutlet]="themeOptions.mediaPreviewCommentsChat"></ng-container>
                  </div>
                }
                @if (
                  isNavigatingToProjectDashboard ||
                  (isMediaPreviewCommentsChatShowing && !hasMediaPreviewCommentsTemplate) ||
                  (!isPlatformCommentsChatShowing && !isMediaPreviewCommentsChatShowing)
                ) {
                  <div
                    class="d-flex flex-column flex-fill align-items-center justify-content-center py-3 w-100 text-center gap-2"
                    role="status"
                    aria-label="Loading comments">
                    <mtm-loading-spinner [size]="32"></mtm-loading-spinner>
                    <span class="text-muted" style="font-size: 0.8rem">Initializing component...</span>
                  </div>
                }
              </div>
            }
            <!-- Explorer-style drive comment shell for org-level pages (brand /
                 drive-mode workspace / campaign): drive feed sidebar that collapses
                 to its rail + composer docked under the content column. Replaces the
                 comment-wrapper above when the page set a drive anchor; the top-nav comment
                 button is hidden for these pages (same model as STUDIO-2249). -->
            <!-- Org pages only (`isOrgDrivePage`): an org page's anchor outlives the page, and
                 elsewhere there is either no entity (settings) or the embedded explorer's own
                 feed (project drive, My Own Space). -->
            @if (!isComparePage && isOrgDrivePage && (platformChatState.context$ | async)?.driveAnchorUuid; as orgDriveAnchor) {
              <mtm-drive-comments-panel
                [style.display]="isTaskPanelOpen ? 'none' : null"
                [elementUuid]="orgDriveAnchor"
                [entityName]="(platformChatState.context$ | async)?.entityName ?? null"
                [entityType]="(platformChatState.context$ | async)?.entityType ?? null"
                [reserveTarget]="rootLayoutContainer" />
            }
            <!-- @if (rightViewMode === 'task') {
              <div
                class="comment-wrapper"
                [class.shared-link-page]="publicReviewLink || publicShareLink"
                [class.fullscreen]="isFullscreen"
                [class.comment-wrapper-hidden]="shouldHideCommentWrapper"
                (transitionend)="onCommentWrapperTransitionEnd($event)"
                [ngStyle]="commentWrapperStyle"
                [ngClass]="commentWrapperClassMap"
                [style.width.px]="commentWrapperWidth"
                >Task wrapper</div
              >
            } -->
          </div>
          @if (!isReportingView) {
            <div class="bottom-container">
              <div class="d-flex align-items-end">
                <ng-container [ngTemplateOutlet]="themeOptions.bottomPanel"></ng-container>
                <mtm-download-popup *ngIf="authUser"></mtm-download-popup>
                <mtm-upload-popup *ngIf="authUser"></mtm-upload-popup>
              </div>
            </div>
          }
        </div>
        @if (themeOptions?.rightPane && !isReportingView) {
          <div class="right-pane">
            <ng-container [ngTemplateOutlet]="themeOptions.rightPane"></ng-container>
          </div>
        }
      </div>
    </div>
  </div>
</div>
